import { render } from "./BaseButton.vue?vue&type=template&id=3ca5ff98&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=3ca5ff98&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3ca5ff98"

export default script